export default "__VITE_ASSET__Br_4OJ8D__"